import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ParentLoginPage, ParentSignupPage, ChildLoginPage, ForgotPasswordPage, ResetPasswordPage, VerifyEmailPage } from './pages/AuthPages';
import { ParentDashboard } from './pages/ParentDashboard';
import { ChildDashboard } from './pages/ChildDashboard';
import CreateStudyMission from './components/CreateStudyMission';
import StudyMissionPlayer from './components/StudyMissionPlayer';
import { StudyMissionLoading } from './pages/StudyMissionLoading';
import './App.css';

function ProtectedRoute({ children, requiredType }) {
  const userType = localStorage.getItem('user_type');
  const token = localStorage.getItem('access_token');

  if (!token || userType !== requiredType) {
    return <Navigate to={requiredType === 'parent' ? '/parent-login' : '/child-login'} />;
  }

  return children;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Autenticação */}
        <Route path="/parent-login" element={<ParentLoginPage />} />
        <Route path="/parent-signup" element={<ParentSignupPage />} />
        <Route path="/verify-email" element={<VerifyEmailPage />} />
        <Route path="/child-login" element={<ChildLoginPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />

        {/* Dashboards */}
        <Route
          path="/parent-dashboard"
          element={
            <ProtectedRoute requiredType="parent">
              <ParentDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/child-dashboard"
          element={
            <ProtectedRoute requiredType="child">
              <ChildDashboard />
            </ProtectedRoute>
          }
        />

        {/* Missões de Estudo */}
        <Route
          path="/parent/study-missions/create"
          element={
            <ProtectedRoute requiredType="parent">
              <CreateStudyMission />
            </ProtectedRoute>
          }
        />
        <Route
          path="/parent/study-missions/:missionId/loading"
          element={
            <ProtectedRoute requiredType="parent">
              <StudyMissionLoading />
            </ProtectedRoute>
          }
        />
        <Route
          path="/parent/study-missions/:missionId"
          element={
            <ProtectedRoute requiredType="parent">
              <StudyMissionPlayer />
            </ProtectedRoute>
          }
        />
        <Route
          path="/child/study-missions/:missionId"
          element={
            <ProtectedRoute requiredType="child">
              <StudyMissionPlayer />
            </ProtectedRoute>
          }
        />

        {/* Rota padrão */}
        <Route path="/" element={<Navigate to="/parent-login" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
